import { gql, TypedDocumentNode } from "@apollo/client";

import {
  Maybe,
  MutationStackRoleBindingBatchCreateArgs,
  MutationStackRoleBindingDeleteArgs,
  MutationStackRoleBindingUpdateArgs,
  QueryStackRoleBindingArgs,
  Role,
  StackRoleBinding,
} from "types/generated";

import { StackRoleBindingView } from "./types";

type StackRoleBindingBatchCreateData = {
  stackRoleBindingBatchCreate: Pick<StackRoleBinding, "id">[];
};

export const STACK_ROLE_BINDING_BATCH_CREATE: TypedDocumentNode<
  StackRoleBindingBatchCreateData,
  MutationStackRoleBindingBatchCreateArgs
> = gql`
  mutation StackRoleBindingBatchCreate($input: StackRoleBindingBatchInput!) {
    stackRoleBindingBatchCreate(input: $input) {
      id
    }
  }
`;

type StackRoleBindingUpdateData = {
  stackRoleBindingUpdate: Pick<StackRoleBinding, "id">;
};

export const STACK_ROLE_BINDING_UPDATE: TypedDocumentNode<
  StackRoleBindingUpdateData,
  MutationStackRoleBindingUpdateArgs
> = gql`
  mutation StackRoleBindingUpdate($id: ID!, $input: StackRoleBindingUpdateInput!) {
    stackRoleBindingUpdate(id: $id, input: $input) {
      id
    }
  }
`;

type StackRoleBindingDeleteData = {
  stackRoleBindingDelete: Maybe<Pick<StackRoleBinding, "id">>;
};

export const STACK_ROLE_BINDING_DELETE: TypedDocumentNode<
  StackRoleBindingDeleteData,
  MutationStackRoleBindingDeleteArgs
> = gql`
  mutation StackRoleBindingDelete($id: ID!) {
    stackRoleBindingDelete(id: $id) {
      id
    }
  }
`;

export type StackRoleBindingsData = {
  stack: { roleBindings: StackRoleBindingView[] };
  roles: Pick<Role, "id" | "name">[];
};

export const STACK_ROLE_BINDINGS_WITH_ROLES: TypedDocumentNode<
  StackRoleBindingsData,
  QueryStackRoleBindingArgs
> = gql`
  query StackRoleBindingsWithRoles($id: ID!) {
    stack(id: $id) {
      roleBindings {
        id
        space {
          id
          name
          accessLevel
        }
        role {
          id
          name
          actions
          description
          isSystem
        }
      }
    }
    roles {
      id
      name
    }
  }
`;
